module.exports = __webpack_public_path__ + "media/images/sports_coaching/anton@3x-d9297f3e083eb53879b1bd07bff3f2a6.jpg";